import sidemenuadminHtml from '../../presentation/menu/sidemenu-admin.html';
import sidemenuHtml from '../../presentation/menu/sidemenu.html';
import adminhomeHtml from '../../presentation/routes/admin/admin-home.html';
import requestresetpasswordHtml from '../../presentation/routes/user/requestresetpassword.html';
import verifyUserHtml from '../../presentation/routes/user/verifyUser.html';
import {ITemplateCacheService} from "angular";

export default function loadTemplates($templateCache: ITemplateCacheService) {
    $templateCache.put('/presentation/menu/sidemenu.html', sidemenuHtml);
    $templateCache.put('/presentation/menu/sidemenu-admin.html', sidemenuadminHtml);
    $templateCache.put('/presentation/routes/user/verifyUser.html', verifyUserHtml);
    $templateCache.put('/presentation/routes/user/requestresetpassword.html', requestresetpasswordHtml);
    $templateCache.put('/presentation/routes/admin/admin-home.html', adminhomeHtml);
}

loadTemplates.$inject = ['$templateCache'];
